import { useState } from "react";
import { Mail, Phone, MapPin, Facebook, Instagram } from "lucide-react";
import "./Footer.css";
import logoFooter from "../assets/logo-footer2.png";
import emailjs from "@emailjs/browser";
export default function Footer() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log("Form Data Submitted:", formData);
  // };
  //   const handleSubmit = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .send(
  //       SERVICE_ID,
  //       TEMPLATE_ID,
  //       {
  //         firstName: formData.firstName,
  //         lastName: formData.lastName,
  //         email: formData.email,
  //         phone: formData.phone,
  //         message: formData.message,
  //       },
  //       PUBLIC_KEY
  //     )
  //     .then(
  //       (result) => {
  //         console.log("Email sent successfully:", result.text);
  //         alert("Message sent successfully!");

  //         setFormData({
  //           firstName: "",
  //           lastName: "",
  //           email: "",
  //           phone: "",
  //           message: "",
  //         });
  //       },
  //       (error) => {
  //         console.error("Email send failed:", error.text);
  //         alert("Failed to send message. Please try again.");
  //       }
  //     );
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const templateParams = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    try {
      await Promise.all([
        emailjs.send(
          SERVICE_ID,
          ADMIN_TEMPLATE_ID,
          templateParams,
          PUBLIC_KEY
        ),
        emailjs.send(
          SERVICE_ID,
          USER_TEMPLATE_ID,
          templateParams,
          PUBLIC_KEY
        ),
      ]);

      // ✅ Success Toast
      setToastText("Thank you! Your message has been sent.");
      setShowToast(true);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });

      setTimeout(() => setShowToast(false), 4000);

    } catch (error) {
      console.error("EmailJS Error:", error);

      // ❌ Error Toast
      setToastText("Failed to send message. Please try again.");
      setShowToast(true);

      setTimeout(() => setShowToast(false), 4000);
    }
  };
  const [showToast, setShowToast] = useState(false);
  const [toastText, setToastText] = useState("");

  const SERVICE_ID = "service_ylxeyzh";
  const ADMIN_TEMPLATE_ID = "template_0zk8wik";
  const USER_TEMPLATE_ID = "template_0ksxt3c";
  const PUBLIC_KEY = "cmgL-_W5Bz85RO2hp";

  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          {/* LEFT SIDE (Links + Contact Info) */}
          <div className="footer-left">
            {/* Wrapper for side-by-side display on mobile */}
            <div className="footer-left-content-mobile">
              {/* Links */}
              <ul className="footer-links">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/e-store">E-Store</a>
                </li>
                <li>
                  <a href="/paint-visualizer">Paint Visualizer</a>
                </li>
                <li>
                  <a href="/about-us">About Us</a>
                </li>
                {/* 👇 Disclaimer button triggers popup */}
                <button onClick={() => setShowDisclaimer(true)}>Disclaimer</button>
              </ul>

              {/* Contact Info */}
              <div className="footer-contact">
                <div>
                  <MapPin size={18} /> Gulshan-e-Iqbal Block 13-A Karachi
                </div>
                <div>
                  <Phone size={18} />
                  <a href="tel:+923147864360">+92 314 7864360</a>
                </div>

                <div>
                  <Mail size={18} />
                  <a href="mailto:info@glamurpaints.com">info@glamurpaints.com</a>
                </div>
              </div>
              <div className="footer-mobile">
                <div>
                  Gulshan-e-Iqbal B 13-A Karachi <MapPin size={18} />
                </div>
                <div>
                  +92 314 7864360 <Phone size={18} />
                </div>
                <div>
                  info@glamurpaints.com <Mail size={18} />
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE - Contact Form */}
          <div className="footer-form">
            <h2>Let’s connect</h2>
            <p>
              Fill out the form below to drop us an email for further inquiries
            </p>

            <form onSubmit={handleSubmit}>
              <div className="name-fields">
                <input
                  type="text"
                  name="firstName" required
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>

              <input
                type="email"
                name="email" required
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
              <textarea
                name="message" required
                placeholder="Message"
                rows="3"
                value={formData.message}
                onChange={handleChange}
              ></textarea>

              <button type="submit">Send</button>
            </form>
          </div>
        </div>

        {/* SOCIAL ICONS + COPYRIGHT */}
        <div className="footer-bottom">
          <div className="footer-logo">
            <img src={logoFooter} alt="Glamur Paints" />
          </div>
          <p className="fcontent">© 2026 Glamur paints. All rights reserved.</p>
          <div className="footer-social">
            <a
              href="https://www.facebook.com/people/Glamur-Paints/100087973459262/"
              target="_blank"
              rel="noreferrer"
            >
              <Facebook size={24} />
            </a>
            <a
              href="https://www.instagram.com/glamur.paints/?igsh=MTF4MzJpcndmeXNkZw%3D%3D#"
              target="_blank"
              rel="noreferrer"
            >
              <Instagram size={24} />
            </a>
          </div>
        </div>
      </footer>

      {/* ✅ Disclaimer Popup */}
      {showDisclaimer && (
        <div className="disclaimer-overlay">
          <div className="disclaimer-box">
            <h3>Disclaimer</h3>
            <p>
              The information provided on the website might not be accurate and
              may vary from reality.
            </p>
            <button
              className="close-disclaimer"
              onClick={() => setShowDisclaimer(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {showToast && (
        <div className="toast">
          {toastText}
        </div>
      )}
    </>
  );
}
